/**
 * Dữ liệu mẫu của màn "Tài khoản của tôi", dùng khi không có Keycloak.
 *
 * ⚠️ Tầng này bị xoá khi chạy thật. **Không** đặt màu hay nhãn hiển thị ở đây.
 */
import type { PhienDangNhap, XacThucCuaToi } from '../modules/tai-khoan/types';

export const MOCK_XAC_THUC: XacThucCuaToi = {
  ungDungXacThuc: [{ id: 'otp-001', nhan: 'Điện thoại cá nhân', taoLuc: '2026-09-12T08:30:00+07:00' }],
  maKhoiPhuc: { trangThai: 'daTao', taoLuc: '2026-09-12T08:34:00+07:00' },
  batBuocMfa: false,
  matKhauDatLuc: '2026-08-01T09:15:00+07:00',
};

/** Rỗng là "chưa cài OTP": trạng thái `?mock=empty` của khối xác thực hai lớp. */
export const MOCK_XAC_THUC_RONG: XacThucCuaToi = {
  ungDungXacThuc: [],
  // Chưa cài OTP thì mục "Mã khôi phục" ẩn; giá trị này không hiện ra.
  maKhoiPhuc: { trangThai: 'chuaTao', taoLuc: null },
  batBuocMfa: false,
  matKhauDatLuc: '2026-08-01T09:15:00+07:00',
};

export const MOCK_PHIEN: PhienDangNhap[] = [
  {
    id: 'phien-001',
    trinhDuyet: 'Chrome/141.0.0',
    heDieuHanh: 'Windows 11',
    ip: '113.161.42.18',
    batDauLuc: '2026-10-20T08:02:00+07:00',
    truyCapCuoiLuc: '2026-10-20T09:41:00+07:00',
    ungDung: ['Cổng ứng dụng tenant'],
    hienTai: true,
  },
  {
    id: 'phien-002',
    trinhDuyet: 'Mobile Safari/26.0',
    heDieuHanh: 'iOS 26.0',
    ip: '14.232.118.7',
    batDauLuc: '2026-10-19T21:15:00+07:00',
    truyCapCuoiLuc: '2026-10-19T22:03:00+07:00',
    ungDung: ['Cổng ứng dụng tenant', 'Cổng quản trị nền tảng'],
    hienTai: false,
  },
];
